import OscDisks from "./OscDisks.js"
import BallArt from './BallArt.js'
import CamParallax from './CamParallax.js'

class MainThreeScene {
  constructor() {
    this.bind()
    this.camera
    this.scene
    this.renderer
    this.controls
    this.progress = 0
  }

  init(container) {
    //RENDERER SETUP
    this.renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true })
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.renderer.debug.checkShaderErrors = true
    this.renderer.outputEncoding = THREE.sRGBEncoding
    container.appendChild(this.renderer.domElement)

    //MAIN SCENE INSTANCE
    this.scene = new THREE.Scene()

    //CAMERA AND ORBIT CONTROLLER
    this.camera = new THREE.PerspectiveCamera(30, window.innerWidth / window.innerHeight, 0.1, 1000)
    this.camera.position.set(0, 0, 20)
    // this.controls = new OrbitControls(this.camera, this.renderer.domElement)
    // this.controls.enabled = false
    // this.controls.maxDistance = 1500
    // this.controls.minDistance = 0

    CamParallax.init(this.camera)

    OscDisks.init(this.scene)
    BallArt.init(this.scene)

    this.raycaster = new THREE.Raycaster()
    this.pointer = new THREE.Vector2(-200, -200)
    this.intersects = []

    //RENDER LOOP AND WINDOW SIZE UPDATER SETUP
    window.addEventListener("resize", this.resizeCanvas)
    window.addEventListener("mousemove", this.onMouseMove)
  }

  update() {

    this.raycaster.setFromCamera(this.pointer, this.camera)

    // calculate objects intersecting the picking ray
    this.intersects = this.raycaster.intersectObjects(this.scene.children)

    this.renderer.render(this.scene, this.camera)
    BallArt.update(this.intersects, this.progress)
    OscDisks.update(this.progress)
    CamParallax.update()
  }

  onMouseMove(event) {
    this.pointer.x = (event.clientX / window.innerWidth) * 2 - 1
    this.pointer.y = - (event.clientY / window.innerHeight) * 2 + 1
  }

  resizeCanvas() {
    this.renderer.setSize(window.innerWidth, window.innerHeight)
    this.camera.aspect = window.innerWidth / window.innerHeight
    this.camera.updateProjectionMatrix()
  }

  bind() {
    this.resizeCanvas = this.resizeCanvas.bind(this)
    this.update = this.update.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    this.init = this.init.bind(this)
  }
}

const _instance = new MainThreeScene()
export default _instance
